module.exports = __webpack_public_path__ + "static/media/align-left.c5f9c195.svg";